/**
 * Vault items are free-form JSON, so a revealed field value is not
 * guaranteed to be a string (null, booleans, numbers and nested objects
 * have all been seen). Normalise to something React can render and
 * `maskValue` can measure.
 */
export function credentialFieldText(value: unknown): string {
  if (value == null) return '';
  if (typeof value === 'string') return value;
  if (typeof value === 'object') {
    try {
      return JSON.stringify(value);
    } catch {
      return String(value);
    }
  }
  return String(value);
}

export function maskCredentialValue(value: unknown): string {
  const text = credentialFieldText(value);
  return text ? '•'.repeat(Math.min(text.length, 20)) : '—';
}
